import { render, staticRenderFns } from "./UsersStateListComponent.vue?vue&type=template&id=b5b15970&"
import script from "./UsersStateListComponent.vue?vue&type=script&lang=js&"
export * from "./UsersStateListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports